import { render, staticRenderFns } from "./HistoryDetailDefaultLayout.vue?vue&type=template&id=59206ad8&scoped=true"
import script from "./HistoryDetailDefaultLayout.vue?vue&type=script&lang=js"
export * from "./HistoryDetailDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59206ad8",
  null
  
)

export default component.exports